/**
 * GeChiUI dependencies
 */
import { __experimentalToolsPanelContext as ToolsPanelContext } from '@gechiui/components';
import { useContext } from '@gechiui/element';

export default function BlockSupportSlotContainer( { Slot, ...props } ) {
	const toolsPanelContext = useContext( ToolsPanelContext );
	return <Slot { ...props } fillProps={ toolsPanelContext } />;
}
